import React from 'react'
import Grid from '../layout/grid'

export default props => (
    <Grid cols={props.cols}>
        <div className='form-group'>
			<label htmlFor={props.name}>{props.label}</label>
			{props.onChange ? (
				<select
					{...props.input}
					className="form-control"
					onChange={props.onChange}
					value={props.value}>
					{!props.semOpcaoVazia &&
					<option value="0">{props.placeholder}</option>}
					{props.options.map(opt => {
						return (
							<option
								key={opt.id}
								value={opt.id}>{opt.valor}</option>
						);
					})}
				</select>
			) : (
				<select
					{...props.input}
					className="form-control">
					{!props.semOpcaoVazia &&
					<option value="0">{props.placeholder}</option>}
					{props.options.map(opt => {
						return (
							<option
								key={opt.id}
								value={opt.id}>{opt.valor}</option>
						);
					})}
				</select>
			)}
       </div>
   </Grid>
)
